import React from "react";

import FilterChips, { Filter } from "../../../../../components/FilterChips/FilterChips";
import { ScimLogsFilter } from "./ScimFilterPanel";

const convertFiltersToReadableList = (filters?: ScimLogsFilter) => {
	const readableList: Filter[] = [];

	if (filters) {
		Object.keys(filters).forEach((filterKey) => {
			const filter = filters[filterKey];

			if (filterKey === "type") {
				readableList.push({
					id: "type",
					type: "string",
					label: "Type",
					value: filter.map((type) => type.label),
				});
			}

			if (filterKey === "status") {
				readableList.push({
					id: "status",
					type: "string",
					label: "Status",
					value: filter.map((status) => status.label),
				});
			}

			if (filterKey === "date") {
				readableList.push({
					id: "date",
					type: "string",
					label: "Date",
					value: filter.label,
				});
			}
		});
	}

	return readableList;
};

type ReadableScimFilterChipsProps = {
	filters: ScimLogsFilter;
	setFilters: (newFilters) => void;
};

const ReadableScimFilterChips = ({ filters, setFilters }: ReadableScimFilterChipsProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (!convertedFilters.length) {
		return null;
	}

	return (
		<FilterChips
			filters={convertedFilters}
			label="Filters applied:"
			onDeleteFilter={(id) => {
				const currentFilters = { ...filters };
				delete currentFilters[id];

				setFilters({ ...currentFilters });
			}}
		/>
	);
};

export default ReadableScimFilterChips;
